import script from "./AddListForm.vue?vue&type=script&setup=true&lang=js"
export * from "./AddListForm.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__